<template>
  <div class="advantageTech">
    <div>
      <div class="fz16">
        平台为保险从业人员、团队供专业的展业系统，助力平台自主经营体进行团队高效管理及业务量提升。
      </div>
      <div class="fz14">
        「云桥」：专项链接和整合保险公司产品与服务，形成智慧产品工厂
      </div>
      <div class="fz14">
        「云创」：数字化保险中后台管理系统和代理人展业平台
      </div>
      <div class="fz14">
        「云链」：链接大型央企B2B供应平台及政府中小企业服务平台，实现获客引流，形成线上保险服务链
      </div>
      <div class="fz14">「保险超脑」：立足数据建模与算法等科技手段打造的超级智慧体。</div>
      <div class="fz14">
        形成保险交易服务中供给端、需求端及销售端的闭环链路，助力精准交易与服务，推动行业在效率、成本、用户体验、风险管理、信用构建五大方面转型优化，为经济发展及社会效益贡献价值。
      </div>
      <!-- <div style="color: #666666;">
        行业领先的保险中介云服务提供商
      </div> -->
      <div><img class="picture_47_view" src="../assets/images/picture_47.png" alt=""></div>
    </div>
    <div>
      <div class="fz16">
        科技平台全方位赋能，科技+保险+健康
      </div>
      <div style="color: #666666;">
        行业领先的保险中介云服务提供商
      </div>
    </div>
    <div class="middle">
      <div class="middleItem">
        <div>
          <img src="../assets/images/technology_icon_01.png" alt="">
        </div>
        <div>
          <div class="techTitle fz20">客户精准引流</div>
          <div class="techText">多元客户引流，精准代理人匹配</div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/technology_icon_02.png" alt="">
        </div>
        <div>
          <div class="techTitle fz20">风险快速识别</div>
          <div class="techText">AFBP风险模型、智能保单识别检视，10分钟定位客户风险敞口</div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/technology_icon_03.png" alt="">
        </div>
        <div>
          <div class="techTitle fz20">海量产品直投</div>
          <div class="techText">涵盖个险产品、互联网产品和团财产品, 支持近百家公司近千款产品在线直投</div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/technology_icon_04.png" alt="">
        </div>
        <div>
          <div class="techTitle fz20">智慧保险工厂</div>
          <div class="techText">团队目标管理,业绩追踪数据分析, 核心指标实时追踪</div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/technology_icon_05.png" alt="">
        </div>
        <div>
          <div class="techTitle fz20">线上服务支持</div>
          <div class="techText">健康医疗服务,展业辅助支持作业全流程</div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/technology_icon_06.png" alt="">
        </div>
        <div>
          <div class="techTitle fz20">数据实时追踪</div>
          <div class="techText">团队目标管理,业绩追踪 数据分析, 核心指标实时追踪</div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/technology_icon_07.png" alt="">
        </div>
        <div>
          <div class="techTitle fz20">方案自动生成</div>
          <div class="techText">多类型产品组合，家庭组合方案，2分钟生成家庭保障方案</div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/technology_icon_08.png" alt="">
        </div>
        <div>
          <div class="techTitle fz20">在线个人门店</div>
          <div class="techText">个人品牌展示、客户咨询导流互联网时代先行军</div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/technology_icon_01.png" alt="">
        </div>
        <div>
          <div class="techTitle fz20">培训管理学院</div>
          <div class="techText">海量知识课程、科学成长路径、AI自主训练</div>
        </div>
      </div>
      <div class="middleItem">
        <div>
          <img src="../assets/images/technology_icon_10.png" alt="">
        </div>
        <div>
          <div class="techTitle fz20">线上客户管理</div>
          <div class="techText">客户标签体系、客户线索追踪、客户精准管理</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'advantageTech',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.advantageTech {
  width: 1024px;
  margin: 0 auto;

  .fz16 {
    color: #2488CA;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .fz14 {
    color: #666;
    line-height: 26px;
  }

  .picture_47_view {
    width: 547px;
    margin: 50px auto;
    display: block;
  }

  &>div {
    margin-top: 40px;
    position: relative;

    .ideaText {
      width: 100%;
      color: #ffffff;
      position: absolute;
      top: 110px;
      text-align: center;

      &>div:first-child {
        font-weight: 600;
      }
    }

    img {
      width: 100%;
    }
  }

  .middle {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .middleItem {
      width: 482px;
      height: 140px;
      box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
      background: url('../assets/images/technology_bg_01.png') no-repeat;
      background-size: 100%;
      display: flex;
      align-items: center;
      padding: 0 40px 0 30px;
      margin-bottom: 32px;

      &>div {
        margin-right: 16px;
      }

      img {
        width: 60px;
      }

      .techTitle {
        // font-weight: 600;
      }

      .techText {
        // font-weight: 600;
        color: #666666;
        margin-top: 4px;
        height: 40px;
      }
    }
  }
}
</style>